<span
  [class.attachments-link]="attachments?.length">{{attachments?.length || 0}} {{ 'SHARED.Attachment(s)' | translate }}</span>
